"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertAppliedPropsToItemProps = void 0;
var uuid_1 = require("uuid");
var convertAppliedPropsToItemProps = function (properties, referenceUuid) {
    var propertiesWithUuids = properties.map(function (prop) { return (__assign(__assign({}, prop), { uuid: (0, uuid_1.v4)() })); });
    var propertiesWithParentUuid = propertiesWithUuids.map(function (prop) {
        var possibleParents = propertiesWithUuids.filter(function (baseProp) {
            return baseProp.valueRow &&
                baseProp.valueRow.hierarchy.uuid ===
                    prop.variableRow.hierarchy.parentUuid;
        });
        if (possibleParents.length === 1) {
            return __assign(__assign({}, prop), { parentUuid: possibleParents[0].uuid });
        }
        return __assign(__assign({}, prop), { parentUuid: null });
    });
    var itemPropertyRows = propertiesWithParentUuid.map(function (prop) { return ({
        uuid: prop.uuid,
        referenceUuid: referenceUuid,
        parentUuid: prop.parentUuid,
        level: prop.variableRow.level,
        variableUuid: prop.variableRow.uuid,
        valueUuid: prop.valueRow ? prop.valueRow.uuid : null,
        objectUuid: prop.objectUuid,
        value: prop.value,
    }); });
    return itemPropertyRows;
};
exports.convertAppliedPropsToItemProps = convertAppliedPropsToItemProps;
//# sourceMappingURL=index.js.map